<template>
  <v-dialog scrollable persistent v-model="dialog">
    <v-card width="540px" style="min-height:400px;">
      <v-card-text >
      
        <v-card-title style="margin-left:-15px">Follow-Up Date</v-card-title>

        <v-row style="max-width:520px;height:400px">
          <v-col cols="12">
            <datepicker v-model="date" format="M/dd/yyyy" name="index" position="left" style="margin-bottom:15px;"></datepicker>
            <div v-if="date !== '0/0/00'"><v-btn size="x-small" style="background:#ff7214;color:white;margin-bottom:5px;margin-top:2px" @click="date = '0/0/00'">Clear Follow-Up Date</v-btn></div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn style="background:gray;color:white" @click="$emit('close')">CANCEL</v-btn>
        <v-btn style="background:#ff7214;color:white" @click="saveDate()" :disabled="disable_save">SAVE</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/compat/app';
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import _ from 'lodash'
import Datepicker from 'vuejs3-datepicker';

export default {
  name: 'BackorderFollowUpDatePopUp',
  components: {Datepicker},
  props:{    
    itemkey: String
  },
  data(){
    return{
      dialog: true,
      date: '0/0/00',
      initial_date: null
    }
  },
  beforeMount(){
    var current_date = this.db.backorders[this.itemkey].follow_up_date
    if(current_date){
      this.date = current_date
      this.initial_date = current_date
    }else{
      this.initial_date = '0/0/00'
    }
  },
  computed: {
    ...mapGetters(['user','db']),
    disable_save() {

      return Moment(this.date).format('M/DD/YY') === this.initial_date || this.date === this.initial_date
    }
  },
  methods:{
    saveDate(){
      var self = this
      var formatted_date = self.date !== '0/0/00' ? Moment(self.date).format('M/DD/YY') : null
      self.$store.state.isLoading = true
      firebase.database().ref('backorders').child(self.itemkey).child('follow_up_date').set(formatted_date)
      setTimeout(() => {
        self.$store.state.isLoading = false
        self.$emit('close')
      }, 2000);
      
    }
  }
}
</script>

<style scoped>
  .v-table > .v-table__wrapper > table > tbody > tr > td{
    font-size: 10px;
  }
  .vuejs3-datepicker__icon{
    padding-top: 2px;
  }
  .vuejs3-datepicker__value{
    padding: 5px 15px;
  }
  .vuejs3-datepicker__calendar{

  }
  .vuejs3-datepicker__calendar-topbar{
    display: none;
  }
</style>


